"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var material_ui_chip_input_1 = __importDefault(require("material-ui-chip-input"));

var styles_1 = require("@material-ui/styles");

var StyledChipInput = styles_1.withStyles({
  chipContainer: {
    padding: '.3rem 0',
    alignItems: 'center',
    boxSizing: 'border-box',
    '&::before': {
      display: 'none'
    },
    '&::after': {
      display: 'none'
    },
    '& > div': {
      margin: '0 8px 8px 0'
    }
  },
  // chip: {
  //   fontSize: '1rem',
  //   fontWeight: 'bold',
  //   color: 'var(--color-orange-darkest)',
  //   backgroundColor: 'var(--color-orange-light)',
  //   '& svg': {
  //     fill: 'var(--color-orange-dark)',
  //   },
  // },
  inputRoot: {
    flex: 'unset',
    width: '100%',
    marginBottom: '1rem'
  },
  input: {
    display: 'block',
    fontSize: 'var(--font-size-medium)',
    transition: 'border .2s'
  },
  focused: {
    '& input': {
      borderBottom: "2px solid #3e51b5"
    }
  },
  inkbar: {
    '&::after': {
      display: 'none'
    }
  }
})(material_ui_chip_input_1.default);
exports.default = StyledChipInput;